module.exports = __webpack_public_path__ + "img/9788993094695.dac936c0.jpg";